import { KeyboardArrowRight } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import React from 'react';
import styles from './AccordionWrapper.module.css';

interface AccordionProps {
  title: string;
  expanded?: boolean;
  allowHide?: boolean;
  handleExpanded?: (e: React.SyntheticEvent, expanded: boolean) => void;
}

export function AccordionWrapper({
  title,
  children,
  expanded = true,
  allowHide = true,
  handleExpanded,
}: AccordionProps & React.PropsWithChildren) {
  return (
    <Accordion disableGutters expanded={expanded} onChange={handleExpanded}>
      <AccordionSummary
        expandIcon={allowHide && <KeyboardArrowRight />}
        aria-controls={`${title.toLowerCase()}-content`}
        id={`${title.toLowerCase()}-content`}
        className={styles.accordion_summary}
        style={allowHide ? { cursor: 'pointer' } : { cursor: 'default' }}
      >
        <Typography component="span">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={styles.accordion_details}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}
